import {notFound} from "@tanstack/react-router";

/** Routes that still live under `/ottopilot` outside the config-driven pages. */
const LEFTOVER_PREFIXES = ["btl-activities", "btl-activity-templates", "source-wise-lead-funnel", "amaron-campaign-overview", "bcg-google-dashboard", "bcg-meta-dashboard"] as const;

export function assertOttopilotPathIsLeftover(pathname: string): void {
    const match = pathname.match(/^\/w\/[^/]+\/ottopilot\/?(.*)$/);
    if (match === null) {
        return;
    }
    const rest = (match[1] ?? "").replace(/\/+$/, "");
    if (rest === "") {
        throw notFound();
    }
    const isLeftover = LEFTOVER_PREFIXES.some((prefix) => rest === prefix || rest.startsWith(`${prefix}/`));
    if (isLeftover !== true) {
        throw notFound();
    }
}
